module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-bold-straight-3JAZKD6K.woff2?31682537723a048ab69e1b3995dc8d23";